import "./App.css";
import React, { useEffect, useState } from "react";
import UIRoutes from "./Routes/Routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Spin } from "antd";
import { jwtDecode } from "jwt-decode";

const queryClient = new QueryClient();

function App() {

  const redirectToNewDomain = () => {
    // window.location.href = "https://www.dev.website.tymeplushr.com/";
    window.location.href = "https://www.tymeplushr.com/";
  };

  //for local use---->
  // const token =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IldTTzIyMyIsInVzZXJJZCI6Im9uYm9hcmRpbmcucWFAc3VwcG9ydHN5c3RlbWRldi5jb20iLCJuYXRpb25hbGl0eSI6IiIsInVzZXJOYW1lIjoiT3duZXIiLCJ1c2VyVHlwZSI6Ik93bmVyIiwicHJvZHVjdHMiOlt7InBheSI6ZmFsc2UsImRlZmF1bHQiOiJzdXBwb3J0IiwiaHIiOmZhbHNlLCJzdXBwb3J0Ijp0cnVlLCJ1cmwiOnsicGF5IjoiaHR0cHM6Ly93d3cucGF5LnR5bWVwbHVzaHIuY29tLyIsInN1cHBvcnQiOiJodHRwczovL3d3dy5kZXYuc3VwcG9ydC50eW1lcGx1c2hyLmNvbS8iLCJociI6Imh0dHBzOi8vd3d3LmFwcC5zeXN0ZW0udHltZXBsdXNoci5jb20vIn19XSwiaWF0IjoxNzQzNzUyMDgwLCJleHAiOjE3NDM3OTUyODB9.VGVynRrNOIVFd2qTO9p6K3mMEsPqpnMGM4ZLU5rYWCA";

  const urlParams = new URLSearchParams(window.location.search);
  var token = urlParams.get("token");

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (token) {
          window.localStorage.removeItem("token");
          window.localStorage.setItem("token", token);
          sessionStorage.setItem(
            "tokenTimestamp",
            new Date().getTime().toString()
          );

          const decodedToken = jwtDecode(token);
          console.log("decodedToken----->", decodedToken)
          // const userId = decodedToken?.userId || "";
          // const userName = decodedToken?.userName || "";
          // const clientId = decodedToken?.clientId || "";
          // const userType = decodedToken?.userType || "";
          // const products = decodedToken?.products || "";

          const user = {
            token: decodedToken,
            userId: decodedToken?.userId || "",
            userName: decodedToken?.userName || "",
            clientId: decodedToken?.clientId || "",
            userType: decodedToken?.userType || "",
          }
  
          window.localStorage.setItem("users", JSON.stringify(user));
          setIsLoggedIn(true);
        }
        let isToken = window.localStorage.getItem("token");

        if (!isToken && token === null) {
          redirectToNewDomain();
        } else {
          setIsLoggedIn(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Invoke the function here after its definition
  }, []);

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <UIRoutes isLoggedIn={isLoggedIn} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
